module.exports = __webpack_public_path__ + "static/img/Adinda Lestari-close.5a191b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Adinda Lestari-close.jpg
// module id = BVqW
// module chunks = 1